module.exports = __webpack_public_path__ + "media/images/giphy_attribution-4e6c5f504f361b533fc3c758b417bdb7.png";